export enum CeaseReason {
  //ChangingSupplier = 'Changing supplier',
  ChangingSupplierDueToPrice = 'Changing supplier due to price',
  ChangingSupplierDueToTechnicalIssues = 'Changing supplier due to technical issues',
  EndUserNoLongerCustomer = 'End user no longer a customer',
  EndUserSiteClosing = 'End user site closing',
  ProvideAndCease = 'Provide and Cease',
  RationalisationOfService = 'Rationalisation of service',
  //ReplacementServiceThroughNeos = 'Replacement service through Neos',
  //SiteClosureRelocation = 'Site closure/relocation',
}

export enum CeaseCategory {
  Quote = 'Quote',
  CeaseService = 'Cease Service',
}

export enum CeaseSubCategory {
  Customer = 'Customer',
  HardCease = 'Hard Cease',
}

export enum CeaseRequestType {
  CeaseRequest = 'Cease Request',
  CeaseQuote = 'Cease Quote',
}

export const ceaseRequestContentByType: Record<CeaseRequestType, { title: string; notes: string[] }> = {
  [CeaseRequestType.CeaseRequest]: {
    title: 'Request the cease of a live service.',
    notes: [
      'Please submit a cease request for each IDN/service identifier.',
      'You can use the Copy functionality to submit multiple requests quickly and efficiently, just add the unique IDN reference.',
      '35 days\' notice is required for Contracts signed pre - 01/07/2026.',
      '45 days\' notice is required for Contracts signed post - 01/07/2026.',
    ],
  },
  [CeaseRequestType.CeaseQuote]: {
    title: 'Request a cease quote for a live service.',
    notes: [
      'Please submit a cease quote request for each IDN/service identifier.',
      'IDN/services that are still within initial contract are subject to Early Termination Fees (ETFs).',
    ],
  },
};

export enum CeaseRequestStatus {
  PendingProcessing = 'Pending Processing',
  Submitted = 'Submitted',
  Failed = 'Failed',
  Completed = 'Completed',
}

export type JsonApiResourceIdentifier = {
  type: string;
  id: string;
};

export type JsonApiRelationship = {
  data?: JsonApiResourceIdentifier | null;
};

export type SubmittedByRelationship = {
  data?: { type: 'user'; id: string } | null;
};

export interface CeaseRelationships {
  submitted_by?: SubmittedByRelationship;
}

export interface UserIncludedResourceAttributes {
  first_name?: string;
  last_name?: string;
  email?: string;
  username?: string;
}

export interface UserIncludedResource {
  type: 'user';
  id: string;
  attributes?: UserIncludedResourceAttributes;
}

export type IncludedResource =
  | UserIncludedResource
  | {
      type: string;
      id: string;
      attributes?: Record<string, any>;
    };

export interface CeaseRequestDetails {
  id: string;
  reference: string;
  status: CeaseRequestStatus | string;
  category?: string;
  subCategory?: string;
  submittedAt: string;
  createdAt?: string;
  updatedAt?: string;

  // ServiceNow integration fields (may be null until synced)
  snowReference?: string;
  integrationStatus?: string;

  customerId: string;

  customerName: string;
  submittedBy: string;
  relationships?: CeaseRelationships;
  included?: IncludedResource[];
  primaryContactName: string;
  primaryContactEmail: string;
  primaryContactPhone: string;
  secondaryContactEmail?: string;
  idn: string;
  requestedCeaseDate: string;
  ceaseReason: string;
  details?: string;
  customerReference?: string;
}

export interface CeaseFormValues {
  requestType: CeaseRequestType | '';
  customerName: string;
  submittedBy: string;
  primaryContactName: string;
  primaryContactEmail: string;
  primaryContactPhone: string;
  secondaryContactEmail: string;
  idn: string;
  requestedCeaseDate: Date | null;
  ceaseReason: CeaseReason | '';
  details: string;
  customerReference: string;
}

// --- API request/response shapes (strict contract) ---

export interface CreateCeaseRequestPayload {
  customer_id: string;
  category: string;
  sub_category: string;
  customer_name: string;
  submitted_by: string;
  primary_contact_name: string;
  primary_contact_email: string;
  primary_contact_phone: string;
  secondary_contact_email?: string;
  idn: string;
  requested_cease_date: string;
  cease_reason: string;
  details?: string;
  customer_reference?: string;
}

export interface CeaseRequestDetailsResponse {
  id: string;
  reference: string;
  status: string;
  category?: string;
  sub_category?: string;
  submitted_at: string;
  created_at?: string;
  updated_at?: string;

  // ServiceNow integration fields (may be null until synced)
  snow_reference?: string;
  integration_status?: string;

  customer_id: string;

  customer_name: string;
  submitted_by: string;
  relationships?: CeaseRelationships;
  included?: IncludedResource[];
  primary_contact_name: string;
  primary_contact_email: string;
  primary_contact_phone: string;
  secondary_contact_email?: string;
  idn: string;
  requested_cease_date: string;
  cease_reason: string;
  details?: string;
  customer_reference?: string;
}

